const axios = require('axios');

const instance = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    'content-type': 'application/json',
    'securitytoken': process.env.SECURITY_TOKEN,
    'Authorization': process.env.AUTHORIZATION,
    'accept': 'application/json',
  },
  data: {}
});

const instancev1 = axios.create({
  baseURL: process.env.API_URL + '_v1',
  headers: {
    'content-type': 'application/json',
    'securitytoken': process.env.SECURITY_TOKEN,
    'Authorization': process.env.AUTHORIZATION,
    'accept': 'application/json',
  },
  data: {}
});

const pipelineInstance = axios.create({
  baseURL: process.env.PIPELINE_URL,
  headers: {
    'content-type': 'application/json',
    'securitytoken': process.env.SECURITY_TOKEN,
    'accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  data: {}
});

const fetchVpbInstance = axios.create({
  baseURL: process.env.PIPELINE_URL,
  headers: {
    'content-type': 'application/json',
    'securitytoken': process.env.SECURITY_TOKEN,
    'Authorization': process.env.AUTHORIZATION
  },
  data: {}
});

const trackingInstance = axios.create({
  baseURL: 'https://g11jbxr01k.execute-api.us-east-1.amazonaws.com/live/ustrackingservice/',
  headers: {
    'content-type': 'application/json',
    'x-api-key': 'OrXxHpntdY8ijxAM11Hkc1QGEeqarRJB3P6frMQm',
    'accept': 'application/json',
  },
  data: {}
});


const clientId = process.env.CLIENTID;
const estateCpId = process.env.ESTATECPID;
const estateId = process.env.ESTATEID;
const capsuleId = process.env.CAPSULEID;
let hutk = '';

export const api = {
  fetchMasterplanConfig: function () {
    return instance.get('/masterplanapi/masterplan/config/get?estatecpid=' + estateCpId, {data: {}});
  },

  fetchHomeGeojson: function () {
    return pipelineInstance.get('/siting/geolocation/estate/' + estateCpId + '/packages');
  },

  fetchLotSummary: function () {
    const modelHomeAPi = instance.get('/houseandlandapi/houseandlandsummary/list?statusid=4200111562122316041', {data: {}});
    const landApi = instancev1.get('/landapi/landsimplesummary/list?estatecpid=' + estateId, {data: {}});
    return axios.all([modelHomeAPi, landApi]).then(axios.spread((...responses) => {
      return {
        lotsummary: responses[1].data,
        homesummary: responses[0].data
      }
    }))
  },

  fetchCompatibleLotSummaryList: function (homeid) {
    console.log(homeid)
    const homeApi = instance.get('/homeapi/homesummary/get?clientproductid='+ homeid.homeid, {data: {}});
    const landApi = instance.get('/homeapi/compatiblelands/simple/list?estatecpid=' + estateCpId + '&plancpid=' + homeid.plancpid, {data: {}});

    // return instance.get('/landapi/landsummary/list?estatecpid=' + estateId + '&plancpid=' + homeid.homeid + '&facadecpid=' + homeid.facadeid, {data: {}});
    return axios.all([homeApi, landApi]).then(axios.spread((...responses) => {
      return {
        homesummary: responses[0].data,
        lotsummary: responses[1].data
      }
    }))
  },

  fetchHomeSummaryList: function () {
    return instance.get('/homeapi/compatiblehomesummary/list', {data: {}});
  },

  fetchHomeSummaryDetail: function (id) {
    return instance.get('/homeapi/homesummary/get?clientproductid='+ id, {data: {}});
  },

  createPackage: function (data) {
    return instance.post('/houseandlandapi/houseandland/create', data)
  },

  getSpecHomesList: function () {
    return instance.get('/houseandlandapi/houseandlandsummary/list?estatecpid=' + estateId + '&spechome=true' + '&statusid=7033741562122316063', {data: {}});
  },

  getPackageDetail: function (id) {
    return instance.get('/houseandlandapi/houseandlandsummary/get?clientproductid='+ id, {data: {}});
  },

  getPackageDetailList: function () {
    return instance.get(`houseandlandapi/houseandlandsummary/list?estatecpid=${estateId}` , {data: {}});
  },

  getDesignSummaryDetail: function (id) {
    return instance.get('/homeapi/designsummary/get?clientproductid='+ id, {data: {}});
  },

  publishContact: function (formData) {
    formData.clientid = clientId;
    formData.capsuleid = capsuleId;
    return instance.post('/crmapi/contact/publish', formData)
  },

  publishToHubspot: function (formData) {
    const url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + process.env.HUBSPOT_PORTAL_ID + '/' + process.env.HUBSPOT_FORM_ID;
    return axios.post(url, formData)
  },

  fetchClient: function (clientId) {
    return instance.get(`/clientapi/get?clientid=${clientId}`, {data: {}});
  },

  fetchLotSummaryV2: function(lotCpId) {
    return instance.get(`/landapi-v2/landsummary/get?lotcpid=${lotCpId}`, {data: {}});
  },

  fetchPartnerSummaryList: function (clientId, clientCompanyId) {
    return instance.get(`/crmapi/partnersummary/list?clientid=${clientId}&clientcompanyid=${clientCompanyId}`, {data: {}});
  },

  fetchCompatibleHomeSummaryListByLotCpIdAndOwnerCcId: function(lotCpId, ownerCcId) {
    return instance.get(`/homeapi/compatiblehomesummary/list?lotcpid=${lotCpId}&ownerccid=${ownerCcId}`, {data: {}});
    // return instance.get(`/homeapi/compatiblehomesummary/list?lotcpid=${lotCpId}`, {data: {}});
  },

  fetchPackageGeojson: function() {
    return pipelineInstance.get(`/siting/geolocation/estate/${estateCpId}/packages?clearCache=false&cache=true`, {data: {}});
  },

  fetchLotGeojson: function() {
    return pipelineInstance.get(`/siting/geolocation/estate/${estateCpId}/lots?clearCache=false&cache=true`, {data: {}});
  },

  fetchHandlSummaryList: function () {
    const estateCpId = estateId; // estatesummaryview returns clientproductid for estatecpid
    return instance.get(`/houseandlandapi/houseandlandsummary/list?clientid=${clientId}&estatecpid=${estateCpId}`, {data: {}});
  },

  listSalesProcessByPackageCpId(id) {
    return fetchVpbInstance.get(`/runwaywsrest/processapi/salesprocess/listbypackagecpid?packagecpid=${id}`)
  },

  fetchPackageGeojsonAndHandlSummaryList: function () {
    const packageGeoJson = this.fetchPackageGeojson();
    const handlSummaryList = this.fetchHandlSummaryList();
    return axios.all([packageGeoJson, handlSummaryList]).then(axios.spread((...responses) => {
      return {
        packageGeoJson: responses[0].data,
        handlSummaryList: responses[1].data
      }
    }))
  },

  postTracking: function (url, data) {
    return trackingInstance.post(url, data);
  },
}



// WEBPACK FOOTER //
// ./src/store/api.js